import ArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft.js";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
const ArrowIcon = styled(ArrowLeftIcon)(
  ({ hidden, disabled, theme }) => ({
    width: 24,
    height: 24,
    color: theme.palette[disabled ? "grey" : "primary"][800],
    ...hidden && { visibility: "hidden" }
  })
);
const Wrapper = styled(Box)(({ theme, disabled }) => ({
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  marginRight: theme.spacing(2),
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: disabled ? 0.3 : 1,
  width: 24,
  height: 24,
  border: "1px solid",
  borderColor: theme.palette[disabled ? "grey" : "primary"][800],
  borderRadius: 12,
  marginLeft: 5
}));
export {
  ArrowIcon,
  Wrapper
};
